var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        _vm.$style.textInput,
        _vm.isFilled && _vm.$style.filled,
        _vm.error && _vm.$style.error,
        _vm.disabled && _vm.$style.disabled,
      ],
    },
    [
      _vm.longText
        ? _c("textarea", {
            directives: [
              {
                name: "case",
                rawName: "v-case",
                value: {
                  upper: _vm.upperCase,
                  lower: _vm.lowerCase,
                },
                expression:
                  "{\n      upper: upperCase,\n      lower: lowerCase\n    }",
              },
            ],
            class: _vm.$style.input,
            attrs: {
              id: _vm.id,
              placeholder: _vm.placeholder,
              disabled: _vm.disabled,
              maxlength: _vm.maxCharacters,
              rows: "10",
            },
            domProps: { value: _vm.value },
            on: {
              input: function ($event) {
                return _vm.$emit("update:value", $event.target.value)
              },
              paste: _vm.onPaste,
            },
          })
        : _c("input", {
            directives: [
              {
                name: "case",
                rawName: "v-case",
                value: {
                  upper: _vm.upperCase,
                  lower: _vm.lowerCase,
                },
                expression:
                  "{\n      upper: upperCase,\n      lower: lowerCase\n    }",
              },
            ],
            class: _vm.$style.input,
            attrs: {
              id: _vm.id,
              type: _vm.type,
              disabled: _vm.disabled,
              placeholder: _vm.placeholder,
              inputmode: _vm.inputmode,
              autocomplete: _vm.autocomplete,
            },
            domProps: { value: _vm.value },
            on: {
              input: function ($event) {
                return _vm.$emit("update:value", $event.target.value)
              },
              paste: _vm.onPaste,
            },
          }),
      _vm.maxCharacters !== null
        ? _c("div", { class: _vm.$style.charactersCount }, [
            _vm._v(" " + _vm._s(_vm.charactersCount) + " "),
          ])
        : _vm._e(),
      _c(
        "transition",
        { attrs: { name: "slide-fade" } },
        [
          _vm.error
            ? _c("Error", [_vm._v(" " + _vm._s(_vm.error) + " ")])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }